<template>
  <v-container fluid>
    <v-row justify="center" align-content="center">
      <v-col cols="7" xl="2" lg="2" md="3" sm="4"> ページが存在しません。 </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
  };
</script>
